/*
 * @FilePath: \nethallofficialaccounts\src\utils\tool.js
 */

// 时间格式转换 2020-11-02 转换成 2020年11月02日
export function formatTime(value) {
    if (value) {
        let dateArr = value.split(" ");
        let date = new Date(dateArr[0]);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        month = month.lenght < 10 ? `0${month}` : month
        day = day.length < 10 ? `0${day}` : day;
        if (dateArr.length <= 1) {
            return `${year}年${month}月${day}日`
        } else {
            return `${year}年${month}月${day}日 ${dateArr[1]}`
        }
    } else {
        return ''
    }
}

/*
 * 查询父级id数组
 */
export const findParentIdsById = (data, targetId) => {
	let result = [];

	const dfs = (nodes, path = []) => {
		for (const node of nodes) {
			const newPath = [...path, node.id];
			if (node.data?node.data.id: node.id === targetId) {
				result = newPath;
				return true;
			}
			if (Array.isArray(node.children) && node.children.length) {
				if (dfs(node.children, newPath)) return true;
			}
		}
		return false;
	};

	dfs(data);
	return result; // 包含自身 ID
}
